import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-registration-history-report',
  templateUrl: './registration-history-report.component.html',
  styleUrls: ['./registration-history-report.component.css']
})
export class RegistrationHistoryReportComponent implements OnInit {
  reportRoute: any;
  constructor(
    private sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<RegistrationHistoryReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
  }
  
  ngOnInit() {
    var url = environment.ReportBaseUrl + "Education/GetRegistrationHistoryShow?NationalCode=" + this.data.NationalCode;
    this.reportRoute = this.sanitizer.bypassSecurityTrustResourceUrl(url.split("null").join(""));
  }
  onNoClick(){
    this.dialogRef.close();
  }
}
